module.exports = __webpack_public_path__ + "img/WoSindDieBären.899c0675.svg";